import { signInPage } from "../features/auth-page.js";
import { closeDateCalendar } from "../components/date-picker.js";
import { S, ui } from "./store.js";
import { esc, initials } from "../domain/format.js";
import { emp, leaveScope, me } from "../services/access.js";
import { chip } from "../components/ui.js";
import { NAV } from "./navigation.js";
import { inbox } from "../services/inbox.js";
import { V } from "./pages.js";
import { enhanceCreationFlows, rememberCreationFields } from "../components/creation-flow.js";
import { mountCaptcha, unmountCaptcha } from "../components/turnstile.js";
import { cookieNotice, legalLinks } from "../components/cookie-notice.js";

function greet() {
  const h = +new Intl.DateTimeFormat("en-PH", {
    timeZone: "Asia/Manila",
    hour: "numeric",
    hourCycle: "h23",
  }).format(new Date());
  return h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
}

function render() {
  rememberCreationFields();
  closeDateCalendar();
  const root = document.getElementById("root");
  unmountCaptcha();
  if (!ui.user) {
    root.innerHTML = signInPage() + cookieNotice();
    void mountCaptcha();
    return;
  }
  if (ui.view === "accounts" || ui.view === "audit") {
    ui.settingsTab =
      ui.view === "audit" ? "audit" : ui.accountsTab === "roles" ? "roles" : "users";
    ui.view = "settings";
  }
  if (ui.view === "admin") {
    if (["users", "roles"].includes(ui.adm || "users")) {
      ui.view = "settings";
      ui.settingsTab = ui.adm === "roles" ? "roles" : "users";
    } else {
      ui.view = "settings";
      ui.settingsTab =
        { company: "workspace", security: "policy", data: "data", audit: "audit" }[ui.adm] ||
        "account";
    }
  }
  const u = me(),
    nav = NAV.filter((n) => !n.foot && (n.grp || n.ok()));
  if (!NAV.find((n) => n.id === ui.view)?.ok()) ui.view = "overview";
  if (location.hash.slice(1) !== ui.view)
    history.pushState(null, "", "#" + ui.view);
  const counts = {
    overview: inbox().length,
    leave: leaveScope().filter((l) => l.status === "PENDING").length,
  };
  const shown = nav.filter((n, i) => !n.grp || (nav[i + 1] && !nav[i + 1].grp));
  const pageTitle = ui.view === "overview" ? "Overview" : NAV.find((n) => n.id === ui.view).t;
  root.innerHTML = `<div class="app${ui.view === "overview" ? " home-layout" : ""}"><aside class="side"><div class="brand"><img src="/brand/milltech-mark.png" width="30" height="30" alt=""><div class="brand-copy"><span>Milltech One</span><span class="workspace-mode ${ui.workspaceMode === "live" ? "is-live" : "is-demo"}">${ui.workspaceMode === "live" ? "LIVE" : "DEMO"}</span></div></div><div class="side-workspace"><span class="side-workspace-mark">M</span><div><strong>Milltech workspace</strong><span>Engineering &amp; Consultancy</span></div></div><nav aria-label="Modules">${shown.map((n) => (n.grp ? `<div class="grp lbl">${n.grp}</div>` : `<button data-go="${n.id}" ${n.id === ui.view ? 'aria-current="page"' : ""}><span>${n.t}</span>${counts[n.id] ? `<span class="badge">${counts[n.id]}</span>` : ""}</button>`)).join("")}</nav><div class="side-foot"><button data-go="settings"${ui.view === "settings" ? ' aria-current="page"' : ""}>Settings</button><button data-act="logout">Sign out</button><div class="side-protected">Protected workspace</div>${legalLinks()}</div></aside>
   <div class="main-shell"><header class="workspace-bar"><div class="workspace-path"><span>Milltech</span><span aria-hidden="true">/</span><strong>${esc(pageTitle)}</strong></div><div class="who"><span class="avatar">${esc(initials(u.name))}</span><div class="who-account"><div class="who-name"><strong>${esc(u.name)}</strong></div><div class="small muted">${esc(S.roles[u.role].name)}</div></div></div></header><main class="main"><div class="wrap"><div class="top"><div><span class="lbl">${ui.view === "overview" ? new Date().toLocaleDateString("en-PH", { timeZone: "Asia/Manila", weekday: "long", month: "long", day: "numeric" }) : "Milltech workspace"}</span><h1>${esc(pageTitle)}</h1>${ui.view === "overview" ? `<p class="home-subtitle">Company snapshot and the work waiting for you.</p>` : ""}</div></div>
    ${V[ui.view]()}</div></main></div></div>${cookieNotice()}`;
  enhanceCreationFlows(ui.view);
}

export { greet, render };
